import { render, staticRenderFns } from "./accountRelevance.vue?vue&type=template&id=8aa21e9e&scoped=true"
import script from "./accountRelevance.vue?vue&type=script&lang=js"
export * from "./accountRelevance.vue?vue&type=script&lang=js"
import style0 from "./accountRelevance.vue?vue&type=style&index=0&id=8aa21e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa21e9e",
  null
  
)

export default component.exports